module.exports = __webpack_public_path__ + "static/img/gdt-and-truck.45ecc16.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gdt-and-truck.jpg
// module id = 332
// module chunks = 0